import { Box, Container, Grid, Card, Typography } from '@mui/material';
import { Atom, Trophy, ShieldCheck, Globe, Star } from 'lucide-react';

const ICON_MAP = {
  Atom: Atom,
  Trophy: Trophy,
  ShieldCheck: ShieldCheck,
  Globe: Globe,
};

export function SchoolHighlights({ data }) {
  const primaryColor = data.primary_color || '#1e3a8a';
  const highlights = Array.isArray(data.school_highlights) ? data.school_highlights : [];

  if (highlights.length === 0) return null;

  return (
    <Box sx={{ py: { xs: 8, md: 10 }, backgroundColor: '#f8fafc' }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', maxWidth: 640, mx: 'auto', mb: 6 }}>
          <Box sx={{ display: 'inline-block', px: 2, py: 0.5, borderRadius: 4, backgroundColor: `${primaryColor}15`, color: primaryColor, mb: 1.5 }}>
            <Typography variant="caption" fontWeight={700} letterSpacing="0.05em">
              WHY WE STAND OUT
            </Typography>
          </Box>
          <Typography variant="h3" fontWeight={800} color="#0f172a" sx={{ fontSize: { xs: '2rem', md: '2.5rem' } }}>
            Pillars of Educational Excellence
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {highlights.map((item, index) => {
            const IconComponent = (item.icon && ICON_MAP[item.icon]) ? ICON_MAP[item.icon] : Star;
            return (
              <Grid size={{ xs: 12, sm: 6, md: 3 }} key={index}>
                <Card
                  elevation={0}
                  sx={{
                    height: '100%',
                    p: 3,
                    borderRadius: 4,
                    backgroundColor: '#ffffff',
                    border: '1px solid #e2e8f0',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-6px)',
                      boxShadow: '0 20px 30px rgba(0,0,0,0.08)',
                      borderColor: `${primaryColor}40`,
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: 54,
                      height: 54,
                      borderRadius: 3,
                      backgroundColor: `${primaryColor}10`,
                      color: primaryColor,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mb: 2.5,
                    }}
                  >
                    <IconComponent size={28} />
                  </Box>
                  <Typography variant="h6" fontWeight={800} color="#0f172a" sx={{ mb: 1.5, lineHeight: 1.3 }}>
                    {item.title}
                  </Typography>
                  {item.description && (
                    <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
                      {item.description}
                    </Typography>
                  )}
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </Box>
  );
}

export default SchoolHighlights;
